import { Accordion, accordionItemBuilder, Box, SkeletonCircle, Text } from '@wix/design-system';
import { useExperiments, useTranslation } from '@wix/fe-essentials/react';
import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';
import { inaccessibleComponentsSessionPagesAtom, inaccessibleLayoutSessionPagesAtom } from '../../atoms/session-atoms';
import { SITE_LEVEL_PAGE_ID } from '../../consts';
import { usePanelStateAtom } from '../../hooks/rules-state';
import { useGetRuleIdToLabelMap } from '../../hooks/use-get-ruleId-to-label-map';
import { useGetRuleIds } from '../../utils/get-rule-ids';
export const RuleResultsSkeleton = _ref => {
  let {
    pageId,
    ruleResultsForGroup
  } = _ref;
  const {
    getGroupData,
    getPagesData
  } = usePanelStateAtom();
  const {
    t
  } = useTranslation();
  const {
    experiments
  } = useExperiments();
  const {
    pageLevelruleIdToLabelKeyMap,
    siteLevelruleIdToLabelKeyMap
  } = useGetRuleIdToLabelMap();
  const pageData = getPagesData().get(pageId);
  const inaccessibleComponentsPages = useAtomValue(inaccessibleComponentsSessionPagesAtom);
  const inaccessibleLayoutPages = useAtomValue(inaccessibleLayoutSessionPagesAtom);
  const getRuleIds = useGetRuleIds();
  const isInaccessibleComponentsRuleEnabled = experiments.enabled('specs.responsive-editor.EnableInaccessibleComponentsRule');

  // TODO: replace static alt text for verticals when phase 2
  // TODO2: this doesn't work for specific pages in drill in. need to investiage and fix.
  const ruleIds = useMemo(() => {
    return ruleResultsForGroup ? ruleResultsForGroup.map(rule => rule.ruleId) : getRuleIds({
      getGroupData,
      inaccessibleComponentsPages,
      inaccessibleLayoutPages,
      isInaccessibleComponentsRuleEnabled,
      pageData,
      pageId
    });
  }, [getRuleIds, getGroupData, pageId, inaccessibleComponentsPages, inaccessibleLayoutPages, ruleResultsForGroup, pageData, isInaccessibleComponentsRuleEnabled]);
  const items = useMemo(() => Array.from(ruleIds).map(ruleId => accordionItemBuilder({
    disabled: true,
    key: ruleId,
    prefix: /*#__PURE__*/React.createElement(Box, {
      padding: "5px 2px 2px 2px"
    }, /*#__PURE__*/React.createElement(SkeletonCircle, {
      diameter: "14px"
    })),
    title: /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "normal"
    }, t(pageId === SITE_LEVEL_PAGE_ID ? siteLevelruleIdToLabelKeyMap[ruleId] : pageLevelruleIdToLabelKeyMap[ruleId]))
  })), [ruleIds, t, pageId, siteLevelruleIdToLabelKeyMap, pageLevelruleIdToLabelKeyMap]);
  return /*#__PURE__*/React.createElement(Accordion, {
    horizontalPadding: "tiny",
    items: items,
    size: "tiny",
    skin: "light",
    transitionSpeed: "fast",
    hideShadow: true
  });
};
//# sourceMappingURL=rule-results-skeleton.js.map